import { render } from "./IshurMachala.vue?vue&type=template&id=55cf8dde&scoped=true"
import script from "./IshurMachala.vue?vue&type=script&lang=js"
export * from "./IshurMachala.vue?vue&type=script&lang=js"

import "./IshurMachala.vue?vue&type=style&index=0&id=55cf8dde&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cf8dde"]])

export default __exports__